import { render, staticRenderFns } from "./correctTable.vue?vue&type=template&id=357760cd&scoped=true"
import script from "./correctTable.vue?vue&type=script&lang=js"
export * from "./correctTable.vue?vue&type=script&lang=js"
import style0 from "./correctTable.vue?vue&type=style&index=0&id=357760cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357760cd",
  null
  
)

export default component.exports